import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router/composables'
// @ts-expect-error js file
import store from '@/store'
import { Studio, StudioTabsInfo } from '@/modules/Studios/types'
import { StudioApi } from '@/enitites/studio'
import StudioHeader from '@/modules/Studios/components/StudioHeader.vue'
import StudioTabs from '@/modules/Studios/components/StudioTabs.vue'
import StudioCompetitionsTab from '@/modules/Studios/components/tabs/StudioCompetitionsTab.vue'
import StudioStudentsTab from '@/modules/Studios/components/tabs/StudioStudentsTab.vue'
import StudioTeachersTab from '@/modules/Studios/components/tabs/StudioTeachersTab.vue'
import StudioAboutTab from '@/modules/Studios/components/tabs/StudioAboutTab.vue'
import Bugsnag from '@bugsnag/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioPage',
  setup(__props) {

const route = useRoute()

const studio = ref<Studio>()
const studioDetails = ref<Studio>()
const tab = ref(0)
const loading = ref(false)

const tabs = ref<StudioTabsInfo[]>([
  { id: 0, name: 'students' },
  { id: 1, name: 'teachers' },
  { id: 2, name: 'competitions' },
  { id: 3, name: 'about' },
])

const initStudio = async () => {
  loading.value = true
  try {
    const studioId = Number(route.params.id)
    const studioData = await StudioApi.fetchStudio(studioId)

    if (!studioData) {
      await store.dispatch('setIsNotFound', true)
      loading.value = false
      return
    }

    studio.value = studioData
    studioDetails.value = studioData
  } catch (error) {
    Bugsnag.notify(error instanceof Error ? error : new Error(String(error)), (event) => {
      event.addMetadata('studio', {
        context: 'Error fetching studio',
        studioId: route.params.id,
      })
    })
    await store.dispatch('setIsNotFound', true)
  } finally {
    loading.value = false
  }
}

const initTab = () => {
  if (!route.query.tab) return
  const currentTabItem = tabs.value.find((tabItem) => tabItem.name === route.query.tab)
  if (currentTabItem) tab.value = currentTabItem.id
}

onMounted(async () => {
  await initStudio()
  initTab()
})

// Watch for route query changes to update the tab
watch(
  () => route.query.tab,
  (newTab) => {
    if (newTab) {
      const currentTabItem = tabs.value.find((tabItem) => tabItem.name === newTab)
      if (currentTabItem) tab.value = currentTabItem.id
    } else {
      // Default to the first tab if no tab is specified in the route
      tab.value = 0
    }
  }
)

return { __sfc: true,route, studio, studioDetails, tab, loading, tabs, initStudio, initTab, StudioHeader, StudioTabs, StudioCompetitionsTab, StudioStudentsTab, StudioTeachersTab, StudioAboutTab }
}

})